import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getFoiFromFli = async (fli = null, apiToken = null) => {
    if (!fli) {
        console.log("no fli");
        return null;
    }
    console.log("CALLING SERVER with getfoibyfli")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getfoibyfli',
            'apiToken': apiToken,
            'fli': fli
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
            //resp.data should be {success: true, formstateid: "", resourcetype: ""}
        }
        console.log("NO RESPONSE from getfoibyfli call");
    }).catch((error) => { console.log(error); });
};

export default getFoiFromFli;